<template>
	<div
		class="wrapper flex bg-white rounded-t border-b-2 border-solid shadow-md px-8"
		:style="subtitle ? 'min-height: 75px; max-height: 90px' : 'min-height: 64px; max-height: 64px'"
	>
		<div class="flex flex-col justify-center mr-4 mt-1" v-if="backButtonTo">
			<div>
				<router-link :to="backButtonTo" class="flex items-center">
					<font-awesome-icon :icon="['fas', 'arrow-left']" class="mr-2" />
					<!--<div class="text-xs" v-if="backButtonTitle">{{ backButtonTitle }}</div>-->
				</router-link>
			</div>
		</div>
		<slot name="beforeTitle" />
		<div class="flex flex-col justify-center">
			<h1 class="text-lg md:text-xl lg:text-2xl font-bold" style="text-align: start">
				<font-awesome-icon :icon="['fas', fontawesomeTitle]" class="text-blue-700 mr-4" v-if="fontawesomeTitle" />{{ title }}
			</h1>
			<div v-if="subtitle" class="flex flex-col font-semibold" style="text-align: start">
				{{ subtitle }}
			</div>
		</div>
		<div v-if="hasDefaultSlot" class="flex flex-grow justify-end items-center">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			required: true,
		},
		subtitle: {
			required: false,
			type: String,
		},
		backButtonTo: {},
		backButtonTitle: {},
		fontawesomeTitle: { type: String, default: null },
	},
	computed: {
		hasDefaultSlot() {
			return !!this.$slots.default;
		},
	},
};
</script>

<style lang="sass" scoped>
.wrapper
	border-color: $sp_blue
</style>
